var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSGripDotsHorizontal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "iconS-grip-dots-horizontal",
    d: "M0,0l0,16l24,0l0,-16l-24,0Z",
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconS-grip-dots-horizontal1",
    serifid: "iconS-grip-dots-horizontal"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.667,12.5c-0.921,-0 -1.667,-0.746 -1.667,-1.667c0,-0.921 0.746,-1.667 1.667,-1.667c0.92,0 1.667,0.746 1.667,1.667c-0,0.921 -0.747,1.667 -1.667,1.667Zm5.556,-0c-0.92,-0 -1.667,-0.746 -1.667,-1.667c0,-0.921 0.747,-1.667 1.667,-1.667c0.921,0 1.667,0.746 1.667,1.667c0,0.921 -0.746,1.667 -1.667,1.667Zm5.557,-3.334c0.92,0 1.667,0.746 1.667,1.667c-0,0.921 -0.747,1.667 -1.667,1.667c-0.92,-0 -1.667,-0.746 -1.667,-1.667c-0,-0.921 0.747,-1.667 1.667,-1.667Zm-11.113,-2.332c-0.921,-0 -1.667,-0.747 -1.667,-1.667c0,-0.92 0.746,-1.667 1.667,-1.667c0.92,0 1.667,0.747 1.667,1.667c-0,0.92 -0.747,1.667 -1.667,1.667Zm5.556,-3.334c0.921,0 1.667,0.747 1.667,1.667c0,0.92 -0.746,1.667 -1.667,1.667c-0.92,-0 -1.667,-0.747 -1.667,-1.667c0,-0.92 0.747,-1.667 1.667,-1.667Zm5.557,3.334c-0.92,-0 -1.667,-0.747 -1.667,-1.667c-0,-0.92 0.747,-1.667 1.667,-1.667c0.92,0 1.667,0.747 1.667,1.667c-0,0.92 -0.747,1.667 -1.667,1.667Zm5.553,5.666c-0.92,-0 -1.667,-0.746 -1.667,-1.667c0,-0.921 0.747,-1.667 1.667,-1.667c0.92,0 1.667,0.746 1.667,1.667c0,0.921 -0.747,1.667 -1.667,1.667Zm0,-9c0.92,0 1.667,0.747 1.667,1.667c0,0.92 -0.747,1.667 -1.667,1.667c-0.92,-0 -1.667,-0.747 -1.667,-1.667c0,-0.92 0.747,-1.667 1.667,-1.667Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSGripDotsHorizontal);
export default __webpack_public_path__ + "static/media/iconS-grip-dots-horizontal.2dbde321be35d6f9cd86f5cef1912a6c.svg";
export { ForwardRef as ReactComponent };